


















import { Component, Vue, Watch } from "vue-property-decorator";
import AlarmEcharts from '@/components/AlarmEcharts.vue';
import axios from 'axios';
const instance = axios.create({
  baseURL: "",
  timeout: 60000,
  headers: { "X-Custom-Header": "foobar" }
});

// 声明组件*****************
@Component({
  components: {
    AlarmEcharts,
  },
})
export default class DataStatistics extends Vue {
  // 属性*****************
  private changeTitleData: Array<Object> = [
    {
      icon:'icon-huojingshujutongjiicon',
      title:'火警报警',
    },
    {
      icon:'icon-guzhangshujutongjiicon',
      title:'故障报警',
    },
    {
      icon:'icon-tuoyuan',
      title:'水压报警',
    },
  ];
  created ():void {
    document.title = '数据统计';
  };
  private getBeforeDate(n:number):string{
    let s;
    let d = new Date();
    let year = d.getFullYear();
    let mon=d.getMonth()+1;
    let day=d.getDate();
    if(day <= n){
      if(mon>1) {
          mon=mon-1;
      }
    else {
      year = year-1;
      mon = 12;
      }
    }
    d.setDate(d.getDate()-n);
    year = d.getFullYear();
    mon=d.getMonth()+1;
    day=d.getDate();
    // s = year+"-"+(mon<10?('0'+mon):mon)+"-"+(day<10?('0'+day):day);
    s = (day<10?('0'+day):day)+'/'+(mon<10?('0'+mon):mon)
    return s;
  }
  private showData:number = 0;
  private list: any = {
    xData:[this.getBeforeDate(7),this.getBeforeDate(6),this.getBeforeDate(5),this.getBeforeDate(4),this.getBeforeDate(3),this.getBeforeDate(2),this.getBeforeDate(1)],
    yData:[0, 0, 0, 0, 0, 0, 0],
    series_item_style:['rgb(0,190,255)','rgb(0,231,255)'],
    // yAxis_max:10,
    yAxis_minInterval:2,
    yAxis_name:'(次数)'
  };

  mounted ():void {
    // console.log(this.getBeforeDate(26))
  }
  // 方法*****************
  // 头部切换
  private changeTitle(i:number): void {
    this.showData = i;
  }
  /** 报警查询列表 */
  private ajaxStatisticSevenDays = (data: object, type: string) => instance.get('/statistic/statistic/wechat/alarms/' + type + '/last_seven_days/', {params: data});

  @Watch('showData', { immediate: true, deep: false })
  onShowDataChanged(val: number, oldVal: number):void {
    switch(val){
      case 0:
        this.ajaxStatisticSevenDays({
          open_id: this['$route']['query']['open_id']
        },'fire').then((res: any)=>{
          this.list["yData"] = res['data']['data']['info'];
        })
        break;
      case 1:
        this.ajaxStatisticSevenDays({
          open_id: this['$route']['query']['open_id']
        },'trouble').then((res: any)=>{
          this.list["yData"] = res['data']['data']['info'];
        })
        break;
      case 2:
        this.ajaxStatisticSevenDays({
          open_id: this['$route']['query']['open_id']
        },'hydraulic').then((res: any)=>{
          this.list["yData"] = res['data']['data']['info'];
        })
        break;
      default:
        this.list["yData"] = [0, 0, 0, 0, 0, 0, 0];
        break;
    }
  }

  // computed
  get hasData(): number {
    return this.list["yData"].some((x: number)=>x!==0);
  }
}
